<router-outlet></router-outlet>
<app-shopping-cart-drawer></app-shopping-cart-drawer>